import { EPOCUS_BG } from "$routes/epocus/_lib/epocus-palette";
import React from "react";
import { LoadingLogo } from "./loading-logo";

export const LoadingPage: FC<React.ComponentProps<typeof LoadingLogo>> = (
  props,
) => (
  <LoadingLogo
    style={{
      minHeight: "100vh",
      backgroundColor: EPOCUS_BG,
      marginInline: "auto",
    }}
    {...props}
  />
);
